module.exports = __webpack_public_path__ + "static/media/3.ab658e97.webp";